import * as React from "react";
import { fetchUserProfile } from "@/hooks/services/workchestra/handler/auth";
import { useUserProfileStore } from "@/stores/user-profile-store";

/**
 * useEnsureUserProfile
 * Loads the user profile into the global store once if it's not already present.
 * Returns the current profile and a loading flag.
 */
export function useEnsureUserProfile() {
  const { userProfile, setUserProfile } = useUserProfileStore();
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let mounted = true;
    if (!userProfile) {
      setIsLoading(true);
      fetchUserProfile()
        .then((profile) => {
          if (!mounted) return;
          setUserProfile(profile);
        })
        .catch((e: any) => {
          if (!mounted) return;
          setError(e?.message || "Failed to load user profile");
        })
        .finally(() => {
          if (!mounted) return;
          setIsLoading(false);
        });
    }
    return () => {
      mounted = false;
    };
  }, [userProfile, setUserProfile]);

  return { userProfile, isLoading, error };
}

export default useEnsureUserProfile;
